import { render, staticRenderFns } from "./peitao.vue?vue&type=template&id=6b7bead9&scoped=true&"
import script from "./peitao.vue?vue&type=script&lang=js&"
export * from "./peitao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7bead9",
  null
  
)

export default component.exports